module.exports = __webpack_public_path__ + "img/1923756.379d068d.png";